import { Controller } from 'stimulus'

export default class WNWController extends Controller {
  static targets = ['bullet', 'item', 'list', 'action']

  connect() {
    this.setActiveBullet()

    // If the first item has data-autoplay true, then play the video inside it
    const video = this.itemTargets[0].querySelector('video')

    // Mute it first
    if (video) {
      video.muted = true
    }

    if (video && this.itemTargets[0].getAttribute('data-autoplay') === 'true') {
      window.addEventListener('load', () => {
        video.play()
      })
    }
  }

  // Sets the active bullet based on the currently visible item
  setActiveBullet() {
    const items = this.itemTargets
    const bullets = this.listTarget.children

    items.forEach((item, index) => {
      if (!item.classList.contains('is-hidden')) {
        bullets[index].classList.add('is-active')
      } else {
        bullets[index].classList.remove('is-active')
      }
    })
  }

  // Called when a bullet is clicked
  showItem(event) {
    const index = this.bulletTargets.indexOf(event.currentTarget)
    const items = this.itemTargets

    items.forEach((item, i) => {
      if (i === index) {
        item.classList.remove('is-hidden')
      } else {
        item.classList.add('is-hidden')
      }
    })

    // Pause all video players on the page
    const videos = document.querySelectorAll('video')
    videos.forEach((video) => {
      video.pause()
    })

    // If the item target has data-autoplay true, then play the video inside it
    const video = items[index].querySelector('video')

    if (video && items[index].getAttribute('data-autoplay') === 'true') {
      video.play()
    }

    this.setActiveBullet()
  }

  // Called when the next button is clicked
  nextItem(event) {
    event.preventDefault()
    const items = this.itemTargets

    // Find the index of the currently visible item
    const currentIndex = items.findIndex((item) => !item.classList.contains('is-hidden'))

    // Hide the current item and show the next one
    items[currentIndex].classList.add('is-hidden')
    items[(currentIndex + 1) % items.length].classList.remove('is-hidden')

    // Pause all video players on the page
    const videos = document.querySelectorAll('video')
    videos.forEach((video) => {
      video.pause()
    })

    // If the next item has data-autoplay true, then play the video inside it
    const video = items[(currentIndex + 1) % items.length].querySelector('video')

    if (video && items[(currentIndex + 1) % items.length].getAttribute('data-autoplay') === 'true') {
      video.play()
    }

    this.setActiveBullet()
  }
}
